
import React, {Component} from 'react'
import { connect } from 'react-redux'
import {Button} from 'reactstrap';
import HeaderComponent from "../../components/header/HeaderComponent";
import ErrorComponent from '../../components/error/ErrorComponent.js'
import LoadingComponent from '../../components/loading/LoadingComponent'
import SaleDetailView from "../../components/sale/SaleDetailView";
import SaleCardView from "../../components/sale/SaleCardView";
import InputTextComponent from "../../components/forms/InputTextComponent";
import SaleFilterView from "./SaleFilterView";
import { LuRefreshCw } from "react-icons/lu";
import DatePicker from '../../components/forms/DatePicker';
import { BiSearch } from "react-icons/bi";

const arraySort = require('array-sort');

var stateManager = require('../../utils/state/stateManager.js');
var navigationPageAction = require('../../utils/state/actions/views/navigationPage/navigationPageAction.js');
const translator = require('../../utils/translator/translator');
const stringUtil = require('../../utils/string/stringUtil');
const businessDateUtil = require('../../utils/dateUtil/businessDateUtil');
const dateUtil = require('../../utils/dateUtil/dateUtil');
const salesLoader = require('../../utils/domain/sales/salesLoader');
const saleCommonUtility = require('../../utils/domain/sales/saleCommonUtility');
const constants = require('../../utils/domain/constants.js');
const logger = require('../../utils/logger/logger');
var screenKeyboardAction = require('../../utils/state/actions/views/onScreenKeyboard/screenKeyboardAction');


class SalesView extends Component 
{
    constructor(props)
    {
        super(props);

        this.state = {};
        this.state.filterCriteria = this.props.filterCriteria;
        this.state.filterCriteria.date = businessDateUtil.getTodayBusinessDate();
        this.state.filterCriteria.searchText = "";
        this.state.salesContext = {};
        this.state.salesContext.sales = [];
        this.state.salesContext.date = businessDateUtil.getTodayBusinessDate();;

        this.state.error = null;
        this.state.isLoadingSales = false;
        this.state.forceReloading = false;
        this.state.filterScreen = null;
        this.state.selectedSaleId = null;
        this.state.unmounted = false;
        this.state.showDatePicker = false;
        this.datePickerContainerRef = React.createRef(null);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
    }

    handleDateChange(newDate) 
    {
        if (newDate) 
        {
            this.setState(prevState => {
                const updatedState = {
                    showDatePicker: false,
                    filterCriteria: {
                        ...prevState.filterCriteria,
                        date: newDate
                    }
                };
                if (!dateUtil.isSame(prevState.salesContext.date, newDate)) 
                {
                    updatedState.salesContext = {
                        ...prevState.salesContext,
                        date: newDate
                    }
                    if (!dateUtil.isSame(newDate, businessDateUtil.getTodayBusinessDate())) 
                    {
                        updatedState.forceReloading = true;
                        updatedState.salesContext.sales = [];
                    }
                }
                return updatedState;
            })
        }
    }

    handleOutsideClick() 
    {
        this.setState({showDatePicker: false});    
    }

    render()
    {
        if (this.state.forceReloading)
        {
            this.state.isLoadingSales = true;
            this.state.forceReloading = false;
            this.loadSales();
        }
        else if (this.isSalesContextDateSameAsBusinessDate())
        {
            this.state.salesContext.sales = stateManager.getStore().getState().todaySales;
        }

        return <div className='h-100'>
                    <div>
                        {this.renderToolbar()}
                    </div>
                    <div style={{padding:'10px'}}>
                        <table style={{width:'100%', tableLayout:'fixed'}}>
                            <tr>  
                                <td style={{width:'65%', verticalAlign:'top'}}>
                                    <div style={{height:'87vh', 
                                                 overflowY:'auto', 
                                                 paddingRight:'5px'}}>
                                        {this.renderLeftPanel()}
                                    </div>
                                </td>
                                <td style={{verticalAlign:'top', border:'1px solid #A9A9A9'}}>
                                    <div style={{height:'87vh', 
                                                 overflowY:'auto',
                                                 paddingLeft:'15px',
                                                 paddingRight:'15px',
                                                 paddingTop:'10px',
                                                 background:'white'
                                                 }}>
                                        {this.renderRightPanel()}
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <DatePicker
                        value={this.state.filterCriteria.date}
                        innerRef={this.datePickerContainerRef}
                        isOpen={this.state.showDatePicker}
                        onChange={this.handleDateChange}
                        onOutSideClick={this.handleOutsideClick}
                    />                            
               </div>
    }

    renderToolbar()
    {
        let isDisabled = this.state.isLoadingSales || this.state.error != null;

        let filterCalendarButtonClassName = "btn-action"
        let dateCaption = translator.getLabel("today");
        
        if (!this.isSalesContextDateSameAsBusinessDate())
            dateCaption = dateUtil.formatDate(this.state.filterCriteria.date, "MMM DD, yyyy");
        
        if (this.state.filterScreen == "calendar")
            filterCalendarButtonClassName = "btn-action-selected"
        else if (!this.isSalesContextDateSameAsBusinessDate())
            filterCalendarButtonClassName = "btn-action-selected"
    
        let filterAttributesButtonClassName = "btn-action"
        if (this.state.filterScreen == "attributes")
            filterAttributesButtonClassName = "btn-action-selected"
        else if (this.isAnyFilteredApplied())
            filterAttributesButtonClassName = "btn-action-selected"

        return <HeaderComponent title={this.props.title}>
                    <table style={{width:'100%'}}>
                        <tr>
                            <td style={{width:'80%', whiteSpace:'nowrap'}}>
                                <div style={{marginRight:'10px'}}>
                                    <InputTextComponent style={{height:'var(--button-height)'}} disabled={isDisabled} placeholder={
                                         <span>
                                         <BiSearch /> {translator.getLabel("search")}
                                    </span>
                                       } 
                                                        value={this.state.filterCriteria.searchText}
                                                        inputTextType="text"
                                                        onValueChange={(value)=>
                                                            {
                                                                this.state.filterCriteria.searchText = value;
                                                                this.setState({});
                                                            }}/>
                                </div>
                            </td>

                            <td>
                                <div style={{marginRight:'70px'}}>
                                    <Button className='btn-action' disabled={isDisabled} style={{minWidth:'5vw'}}
                                            onClick={()=>
                                            {
                                                logger.usage("SalesView.Refresh", "Staff clicked refresh button to refresh sales");
                                                this.state.forceReloading = true;
                                                this.state.salesContext.sales = [];
                                                this.setState({});
                                            }}>
                                        <LuRefreshCw/></Button>
                                </div>
                            </td>

                            <td>
                                <div style={{marginRight:'5px'}}>
                                    <Button innerRef={this.datePickerContainerRef} className={filterCalendarButtonClassName} disabled={isDisabled} style={{minWidth:'10vw'}}
                                    onClick={()=>
                                    {
                                        logger.usage("SalesView.Calendar", "Staff clicked calendar button to change date");
                                        this.setState(prevState => ({showDatePicker: !prevState.showDatePicker, selectedSaleId: null}));
                                    }}>{dateCaption}</Button>
                                </div>
                            </td>
                            <td>
                                <div style={{marginRight:'70px'}}>
                                    <Button className={filterAttributesButtonClassName} disabled={isDisabled}
                                            onClick={()=>
                                            {
                                                logger.usage("SalesView.Filter", "Staff clicked filter button to change filters");
                                                this.state.selectedSaleId = null;
                                                if (this.state.filterScreen == "attributes")
                                                    this.state.filterScreen = null;
                                                else
                                                    this.state.filterScreen = "attributes";
                                                this.setState({});
                                            }} >{translator.getLabel("filter")}</Button>
                                </div>
                            </td>

                            <td style={{whiteSpace:'nowrap'}}>
                                <Button className='btn-cancel'
                                        onClick={()=>
                                            {
                                                logger.usage("SalesView.Exit", "Staff clicked exit button to exit");
                                                this.state.unmounted = true;
                                                stateManager.getStore().dispatch(screenKeyboardAction.createAction(null));
                                                stateManager.getStore().dispatch(navigationPageAction.createAction(null))
                                            }}>{translator.getLabel("exit")}
                                </Button>
                            </td>

                            
                        </tr>
                    </table>
               </HeaderComponent>
    }

    renderLeftPanel()
    {
        if (this.state.isLoadingSales)
        {
            return <div className='h-100 caption primary-color d-flex flex-column justify-content-center align-items-center'>
                    <LoadingComponent waitMessage={translator.getLabel("please_wait_loading_sales")}/>
                </div>
        }

        if (this.state.error != null)
        {
            return <div className='h-100 d-flex flex-column justify-content-center'>
                        <ErrorComponent error={this.state.error}/>
                   </div>
        }
        
        let sales = this.getFilteredAndSortedSales();
        if (sales.length <= 0)
        {
            return <div className='h-100 caption primary-color d-flex flex-column justify-content-center align-items-center'>
                            <div>
                                {translator.getLabel("no_sales_found")}   
                            </div>                            
                    </div>
        }

        let components = [];
        sales.forEach (sale =>
        {
            components.push(<SaleCardView sale={sale} isSelected={this.state.selectedSaleId == sale.id} onSelect={(sale) =>
            {
                this.state.selectedSaleId = sale.id;
                this.state.filterScreen = null;
                this.setState({});
            }}/>)
        })

        return <div>{components}</div>
    }

    renderRightPanel()
    {
        if (this.state.isLoadingSales || this.state.error != null)
        {
            return null;
        }

        if (this.state.filterScreen == null)
        {
            if (this.state.selectedSaleId == null)
                return null;

            let sale = this.state.salesContext.sales.find(s => s.id == this.state.selectedSaleId);
            return <div>
                        <div style={{paddingRight:'0px'}}>
                            <SaleDetailView sale={sale}/>
                        </div>
                        
                    </div>
        }

        return this.renderFilterScreen();
    }

    renderFilterScreen()
    {
        let clonedFilterCriteria = JSON.parse(JSON.stringify(this.state.filterCriteria));

        return <SaleFilterView 
                    view={this.state.filterScreen} 
                    filterCriteria={clonedFilterCriteria}
                    onApply={()=>
                    {
                        this.state.filterScreen = null;
                        this.state.filterCriteria = clonedFilterCriteria;

                        if (stringUtil.isStringNullOrEmpty(this.state.filterCriteria.date))
                            this.state.filterCriteria.date = businessDateUtil.getTodayBusinessDate();

                        if (!dateUtil.isSame(this.state.salesContext.date, this.state.filterCriteria.date))
                        {
                            this.state.salesContext.date = this.state.filterCriteria.date;
                            if (!dateUtil.isSame(this.state.salesContext.date, businessDateUtil.getTodayBusinessDate()))
                            {
                                this.state.forceReloading = true;
                                this.state.salesContext.sales = [];
                            }
                        }

                        this.setState({});
                    }}/>
    }

    getFilteredAndSortedSales()
    {
        let sales = [];
        this.state.salesContext.sales.forEach (sale =>
        {
            if (sale.saleType == constants.SaleTypeHold)
            {
                if (!saleCommonUtility.isSaleHoldByStaff(sale))
                    return;
            }

            if (stringUtil.areStringSame(this.state.filterCriteria.paymentStatus, "paid") && !sale.isSaleFullyPaid)
                return;

            if (stringUtil.areStringSame(this.state.filterCriteria.paymentStatus, "unpaid") && sale.isSaleFullyPaid)
                return;

            if (!stringUtil.isStringNullOrEmpty(this.state.filterCriteria.dispatchType) && !stringUtil.areStringSame(sale.dispatchType, this.state.filterCriteria.dispatchType))
                return;

            if (!stringUtil.isStringNullOrEmpty(this.state.filterCriteria.venueCode) && !stringUtil.areStringSame(sale.venueCode, this.state.filterCriteria.venueCode))
                return;

            if (!stringUtil.isStringNullOrEmpty(this.state.filterCriteria.storefrontId) && !stringUtil.areStringSame(sale.storefrontId, this.state.filterCriteria.storefrontId))
                return;

            if (stringUtil.areStringSame(this.state.filterCriteria.saleStatus, "cancelled") && !sale.isCancelled)
                return;

            if (stringUtil.areStringSame(this.state.filterCriteria.saleStatus, "hold") && !saleCommonUtility.isSaleHoldByStaff(sale))
                return;

            if (stringUtil.areStringSame(this.state.filterCriteria.saleStatus, "active") && (sale.isCancelled || saleCommonUtility.isSaleHoldByStaff(sale)))
                return;

            if (!stringUtil.isStringNullOrEmpty(this.state.filterCriteria.searchText))
            {
                var searchText = stringUtil.trimString(this.state.filterCriteria.searchText);
                let matched = false;
                if (sale.customerName != null &&
                    sale.customerName.toLowerCase().includes(searchText.toLowerCase()))
                {
                    matched = true;
                }

                if (sale.number != null &&
                    sale.number.toLowerCase().includes(searchText.toLowerCase()))
                {
                    matched = true;
                }

                if (sale.customerPhoneNumber != null &&
                    sale.customerPhoneNumber.toLowerCase().includes(searchText.toLowerCase()))
                {
                    matched = true;
                }

                if (sale.deliveryAddress != null &&
                    sale.deliveryAddress.toLowerCase().includes(searchText.toLowerCase()))
                {
                    matched = true;
                }

                if (!matched)
                    return;
            }

            sales.push(sale);
            
        });

        return arraySort(sales, "dateTime", { reverse: true });
    }

    
    isAnyFilteredApplied()
    {
        if (!stringUtil.isStringNullOrEmpty(this.state.filterCriteria.paymentStatus))
            return true;

        if (!stringUtil.isStringNullOrEmpty(this.state.filterCriteria.dispatchType))
            return true;

        if (!stringUtil.isStringNullOrEmpty(this.state.filterCriteria.venueCode))
            return true;

        if (!stringUtil.isStringNullOrEmpty(this.state.filterCriteria.storefrontId))
            return true;

        if (!stringUtil.isStringNullOrEmpty(this.state.filterCriteria.saleStatus))
            return true;

        return false;
    }

    async loadSales()
    {
        try
        {
            if (this.isSalesContextDateSameAsBusinessDate())
            {
                await salesLoader.loadTodaysSalesAndSalesStatus();
            }
            else
            {
                this.state.salesContext.sales = await salesLoader.loadSales(this.state.salesContext.date);
            }
            
            if (this.state.unmounted) return;
            this.state.isLoadingSales = false;
            this.setState({});
        }
        catch(error)
        {
            logger.error(`Error occurred while loading sales in sales view. ${error}`, {}, error);
            if (this.state.unmounted) return;

            this.state.isLoadingSales = false;
            this.state.error = error;
            this.setState({});
        }
    }

    isSalesContextDateSameAsBusinessDate()
    {
        return dateUtil.isSame(this.state.salesContext.date, businessDateUtil.getTodayBusinessDate());
    }
}

const mapStateToProps = state => 
{
    return { 
                todaysSalesUpdatedDateTime: state.todaysSalesUpdatedDateTime,
          }
}

export default connect(mapStateToProps)(SalesView)